import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';
import { SettingValueModel } from 'src/app/models/api/setting-value.model';
import { AutoExportSettingsModel } from 'src/app/components/settings/components/auto-export/auto-export-settings.model';

@Injectable({
    providedIn: 'root'
})
export class SettingsApiClient {

    private API_ENDPOINT = environment.apiUrl + "/fe-api/settings";
    private forOrganisationGuid: string = "";
    private cache!: Observable<SettingValueModel[]> | null;
    private autoExportForOrganisationGuid: string = "";
    private autoExportCache!: Observable<AutoExportSettingsModel> | null;

    constructor(private httpClient: HttpClient) { }
    /**
     * Grab organisation WORKFLOW settings (for now)
     * @param organisationGuid 
     * @returns 
     */
    getWorkflowSettings(organisationGuid: string) {
        if (this.forOrganisationGuid === organisationGuid) {
            return this.getCache(organisationGuid);
        } else {
            return this.getNonCache(organisationGuid);
        }
    }

    storeAutoExport(organisationGuid: string, autoExportSettings: AutoExportSettingsModel) {
        return this.httpClient.post(this.API_ENDPOINT + "/organisation/" + organisationGuid + "/auto-export", autoExportSettings).pipe(
            tap(() => {
                this.autoExportForOrganisationGuid = organisationGuid;
                this.autoExportCache = of(autoExportSettings).pipe(shareReplay(1));
            })
        );
    }
    getAutoExport(organisationGuid: string): Observable<AutoExportSettingsModel> {
        if (this.autoExportForOrganisationGuid === organisationGuid && this.autoExportCache) {
            return this.autoExportCache;
        }
        this.autoExportForOrganisationGuid = organisationGuid;
        this.autoExportCache = this.httpClient.get<AutoExportSettingsModel>(this.API_ENDPOINT + "/organisation/" + organisationGuid + "/auto-export").pipe(
            shareReplay(1)
        );
        return this.autoExportCache;
    }

    refreshCache() {
        this.cache = this.getNonCache(this.forOrganisationGuid).pipe(
            map(data => data
            ),
            shareReplay(1)
        );
    }
    private getCache(organisationGuid: string) {
        if (!this.cache) {
            this.cache = this.getNonCache(organisationGuid).pipe(
                map(data => data
                ),
                shareReplay(1)
            );
        }
        return this.cache;
    }
    private getNonCache(organisationGuid: string) {
        this.forOrganisationGuid = organisationGuid;
        return this.httpClient.get<SettingValueModel[]>(this.API_ENDPOINT + "/organisation/" + organisationGuid + "/workflows");
    }
}